import * as React from 'react';
import 'rxjs/add/operator/debounce';
import 'rxjs/add/operator/debounceTime';
import { ConsoleLib } from '../libs/console.lib';

export class ListConsole extends React.Component<any, any> {
    private console: ConsoleLib = new ConsoleLib(this.props.config);

    render() {
        return (
            <div className={this.props.className}>
                <div className="content-box">
                    <h3 className="content-box-header bg-white">Search</h3>
                    <div className="content-box-wrapper w-100 bg-white">
                        <div className=" w-100">
                            {this.props.render && this.props.render(this.console)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

/*
 if (this.props.config && this.props.config.onKeyword$) {
        this.props.config.onKeyword$.next(event.target.value);
    }
 */



// WEBPACK FOOTER //
// ./src/components/structurals/list-console.tsx